export enum AdminErrorTypesRoutes {
  Root = '',
  ImportJson = 'import-json',
}
